import mapboxgl from 'mapbox-gl';

$(function () {
    mapboxgl.accessToken = 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNqcnN2YTh4NzBudDY0M3FzeXU3OHp3ZHUifQ.QF3mFD2UlGHGG4q-2-eKhQ';

    const mapboxes = document.querySelectorAll('.mapbox-single');
    if (mapboxes.length > 0) {
        mapboxes.forEach(mapbox => {
            initMap(mapbox, mapbox.querySelector('.marker'));
        });
    }
});

const initMap = (mapboxMapElement, mapboxMarkerElement) => {
    if (!mapboxMapElement || !mapboxMarkerElement) {
        return;
    }

    const lat = mapboxMarkerElement.dataset.lat;
    const lng = mapboxMarkerElement.dataset.lng;

    if (!lat || !lng) {
        return;
    }

    const markerPosition = new mapboxgl.LngLat(lng, lat);

    const map = new mapboxgl.Map({
        container: mapboxMapElement,
        style: 'mapbox://styles/blackdesk/ckli2qu1p15et18rxcw3cbg3h',
        center: markerPosition,
        maxZoom: 18,
        zoom: 14,
        minZoom: 6,
    });

    map.on('load', function() {
      map.resize();
    });

    const marker = document.createElement('div');
    marker.className = 'marker';
    marker.style.backgroundImage = 'url(/wp-content/themes/colijnsplaat/resources/assets/images/marker.svg)';
    marker.style.width = '46px';
    marker.style.height = '70px';
    marker.style.marginTop = '-25px';
    marker.style.backgroundSize = 'contain';
    marker.style.backgroundRepeat = 'no-repeat';
    marker.style.backgroundPosition = 'center center';
    new mapboxgl.Marker(marker).setLngLat(markerPosition).addTo(map);
};
